import { render, staticRenderFns } from "./TheHeaderQuickReplies.vue?vue&type=template&id=2f153388&scoped=true"
import script from "./TheHeaderQuickReplies.vue?vue&type=script&lang=js"
export * from "./TheHeaderQuickReplies.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderQuickReplies.vue?vue&type=style&index=0&id=2f153388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f153388",
  null
  
)

export default component.exports